import { render } from "./PickEm.vue?vue&type=template&id=22d7f09b"
import script from "./PickEm.vue?vue&type=script&lang=js"
export * from "./PickEm.vue?vue&type=script&lang=js"

import "./PickEm.vue?vue&type=style&index=0&id=22d7f09b&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__